import { render, staticRenderFns } from "./CustomCarousel.vue?vue&type=template&id=26b6f039&scoped=true"
import script from "./CustomCarousel.vue?vue&type=script&lang=js"
export * from "./CustomCarousel.vue?vue&type=script&lang=js"
import style0 from "./CustomCarousel.vue?vue&type=style&index=0&id=26b6f039&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b6f039",
  null
  
)

export default component.exports